import { SelectOption } from '@/components/elements/select'

export const modalitiesMap: SelectOption[] = [
	{ label: 'Asesoría a distancia', value: 'Asesoría a distancia' },
	{
		label: 'Asesoría en las instalaciones',
		value: 'Asesoría en las instalaciones',
	},
]
